import { render, staticRenderFns } from "./index-tab.vue?vue&type=template&id=2b0a7aaa&scoped=true&"
import script from "./index-tab.vue?vue&type=script&lang=js&"
export * from "./index-tab.vue?vue&type=script&lang=js&"
import style0 from "./index-tab.vue?vue&type=style&index=0&id=2b0a7aaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a7aaa",
  null
  
)

export default component.exports